(() => {
  if (customElements.get('spotit-product-status')) return;

  class SpotItProductStatus extends HTMLElement {
    connectedCallback() {
      this.duration = 900000;
      this.storageKey = `spotit-countdown-v12-${this.dataset.productId || 'product'}`;
      this.clock = this.querySelector('[data-sps-clock]');
      this.progress = this.querySelector('[data-sps-progress]');
      this.dateNode = this.querySelector('[data-sps-date]');
      const now = Date.now();
      let saved = 0;
      try { saved = Number(sessionStorage.getItem(this.storageKey)); } catch (_) { /* Storage is optional. */ }
      this.deadline = saved > now && saved <= now + this.duration ? saved : now + this.duration;
      this.storeDeadline();
      this.tick();
      clearInterval(this.interval);
      this.interval = setInterval(() => this.tick(), 1000);
      this.visibilityHandler = () => { if (!document.hidden) this.tick(); };
      document.addEventListener('visibilitychange', this.visibilityHandler);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.visibilityHandler);
    }

    storeDeadline() {
      try { sessionStorage.setItem(this.storageKey, String(this.deadline)); } catch (_) { /* Timer still works without storage. */ }
    }

    tick() {
      const now = Date.now();
      if (now >= this.deadline) {
        this.deadline = now + this.duration;
        this.storeDeadline();
      }
      const remaining = Math.max(0, Math.ceil((this.deadline - now) / 1000));
      const minutes = Math.floor(remaining / 60);
      const seconds = remaining % 60;
      if (this.clock) {
        this.clock.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        this.clock.setAttribute('aria-label', `${minutes} minutes ${seconds} seconds remaining`);
      }
      // Empty at 15:00, half full at 07:30, and full at the end of the cycle.
      // Anchor the left edge and smoothly advance the right edge as time elapses.
      if (this.progress) {
        const elapsed = Math.max(0, Math.min(1, 1 - (this.deadline - now) / this.duration));
        if (this.progressFraction === undefined || elapsed < this.progressFraction) {
          // Reset instantly rather than animating backwards when the timer restarts.
          this.progress.style.transition = 'none';
          this.progress.style.transform = `scaleX(${elapsed})`;
          void this.progress.offsetWidth;
          this.progress.style.transition = '';
        } else {
          this.progress.style.transform = `scaleX(${elapsed})`;
        }
        this.progressFraction = elapsed;
      }
      this.updateShippingDate(now);
    }

    updateShippingDate(now) {
      if (!this.dateNode) return;
      const options = { timeZone: 'Asia/Bahrain', weekday: 'short', month: 'short', day: 'numeric' };
      let parts;
      try { parts = new Intl.DateTimeFormat('en-US', options).formatToParts(new Date(now)); }
      catch (_) { parts = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' }).formatToParts(new Date(now)); }
      const value = (type) => parts.find((part) => part.type === type)?.value || '';
      const formatted = `${value('weekday')}, ${value('month')} ${value('day')}`;
      if (formatted !== this.lastDate) {
        this.dateNode.textContent = formatted;
        this.lastDate = formatted;
      }
    }
  }

  customElements.define('spotit-product-status', SpotItProductStatus);
})();
